import React from "react";
import { HorizontalNote } from "./HorizontalNote";

export function AsteriskNotification(props: { children?: React.ReactNode }) {
  return (
    <HorizontalNote>
      Fields marked with an asterisk (<span className="required">*</span>) are
      required.{props.children}
    </HorizontalNote>
  );
}
